import { useCallback, useEffect, useState } from 'react';
import { apiRequest } from '../utils/apiUtils';
import type { JoinApplicationStatus } from '@myfutbolapp/shared';

export interface MyJoinApplicationRow {
  id: string;
  status: JoinApplicationStatus;
  message: string;
  preferredPosition?: string | null;
  selfRatedSkill?: number | null;
  createdAt: string;
  match: {
    id: string;
    location: string;
    date: string;
    time: string;
    status: string;
    isPublic: boolean;
    price: number | null;
    creatorId: string;
    creator: { id: string; name: string } | null;
  } | null;
}

export function useMyJoinApplications() {
  const [rows, setRows] = useState<MyJoinApplicationRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await apiRequest<MyJoinApplicationRow[]>('/matches/my-join-applications');
    if (res.error) {
      setError(res.error);
      setRows([]);
    } else {
      setRows(Array.isArray(res.data) ? res.data : []);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const cancel = useCallback(
    async (matchId: string, applicationId: string) => {
      const res = await apiRequest(
        `/matches/${matchId}/join-applications/${applicationId}/cancel`,
        { method: 'POST' }
      );
      if (!res.error) {
        await load();
      }
      return res;
    },
    [load]
  );

  return { rows, loading, error, refresh: load, cancel };
}
